import { render, staticRenderFns } from "./cardcomp.vue?vue&type=template&id=8a4e2b4e"
import script from "./cardcomp.vue?vue&type=script&lang=js"
export * from "./cardcomp.vue?vue&type=script&lang=js"
import style0 from "./cardcomp.vue?vue&type=style&index=0&id=8a4e2b4e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports